import Viewer from 'viewerjs'
let preview = {
  preview: function(el) {
    el.setAttribute('style', 'cursor: zoom-in;')
    let viewer = new Viewer(el, {
      url: el.getAttribute('src'),
      navbar: false,
      title: false,
      toolbar: {
        zoomIn: true,
        zoomOut: true,
        play: {
          show: 0
        },
        rotateLeft: true,
        reset: true,
        rotateRight: true,
        flipHorizontal: true,
        flipVertical: true
      }
    })
    if (!viewer) {
      console.log(viewer)
    }
    el.addEventListener('click', () => {
      viewer = new Viewer(el, {
        url: el.getAttribute('src'),
        navbar: false,
        title: false,
        toolbar: {
          zoomIn: true,
          zoomOut: true,
          play: {
            show: 0
          },
          rotateLeft: true,
          reset: true,
          rotateRight: true,
          flipHorizontal: true,
          flipVertical: true
        }
      })
    })
  }
}
export default preview
